import { createContextPart } from "../create-context-part.js";
import { useSliderContext } from "./context.js";
//#region src/ui/slider/track.tsx
/** Contains the slider's visual track and interactive hit zone. */
const SliderTrack = createContextPart({
	displayName: "SliderTrack",
	tag: "div",
	useContext: useSliderContext
});
//#endregion
export { SliderTrack };

//# sourceMappingURL=track.js.map